<div class="modal-header">
  <h4 class="modal-title" id="reportModalHeader">{{ modalTitle }}</h4>
</div>
<div class="modal-body">
  @if (mvrReportDetails) {
    <nwx-mvr-report-details
      [reportDetails]="mvrReportDetails"
    ></nwx-mvr-report-details>
  }
  @if (alhReportDetails) {
    <nwx-alh-report-details
      [reportDetails]="alhReportDetails"
    ></nwx-alh-report-details>
  }
  @if (plhReportDetails) {
    <nwx-plh-report-details
      [reportDetails]="plhReportDetails"
      >
    </nwx-plh-report-details>
  }
  @if (currentCarrierReportDetails?.length) {
    <nwx-current-carrier-form
      [model]="currentCarrierModel$ | async"
      [options]="currentCarrierOptions$ | async"
      (valueChange)="onCurrentCarrierChange($event)"
    ></nwx-current-carrier-form>
  }
  @if (isManualInfractions) {
    <div>
      @for (member of (members$ | async); track member.entityId; let i = $index) {
        <div class="bolt-space-bottom-xl">
          <nwx-infractions-form
            [person]="member || {}"
            [personIndex]="i"
            [isReportsModal]="true"
            (valueChange)="onInfractionChange($event)"
          ></nwx-infractions-form>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  @if (showSaveAndCancel) {
    <bolt-button-bar>
      <bolt-button
        slot="cancel"
        [attr.id]="'vrm-cancel'"
        (click)="activeModal.close()"
        >Cancel</bolt-button
        >
        <bolt-button slot="forward" type="solid" [attr.id]="'vrm-save'" (click)="onSave()"
          >Save</bolt-button
          >
        </bolt-button-bar>
      } @else {
        <bolt-button-bar>
          <bolt-button
            slot="back"
            [attr.id]="'vrm-close'"
            (click)="activeModal.close()"
            >Close</bolt-button
            >
          </bolt-button-bar>
        }
      </div>
